var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicapple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5a34300bba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.484375 2.484375 L 109.257812 2.484375 L 109.257812 109.257812 L 2.484375 109.257812 Z M 2.484375 2.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5a2aaf301"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.5 2.484375 L 93.242188 2.484375 C 93.769531 2.484375 94.289062 2.507812 94.8125 2.5625 C 95.335938 2.613281 95.851562 2.6875 96.367188 2.792969 C 96.882812 2.894531 97.390625 3.019531 97.890625 3.171875 C 98.394531 3.324219 98.886719 3.503906 99.371094 3.703125 C 99.855469 3.902344 100.332031 4.128906 100.792969 4.375 C 101.253906 4.621094 101.703125 4.890625 102.140625 5.183594 C 102.578125 5.472656 103 5.785156 103.402344 6.121094 C 103.808594 6.453125 104.199219 6.804688 104.566406 7.175781 C 104.9375 7.546875 105.292969 7.933594 105.625 8.339844 C 105.957031 8.746094 106.269531 9.164062 106.558594 9.601562 C 106.851562 10.039062 107.121094 10.488281 107.367188 10.949219 C 107.617188 11.414062 107.839844 11.886719 108.039062 12.371094 C 108.242188 12.855469 108.417969 13.347656 108.570312 13.851562 C 108.722656 14.351562 108.847656 14.859375 108.953125 15.375 C 109.054688 15.890625 109.128906 16.410156 109.183594 16.929688 C 109.234375 17.453125 109.257812 17.976562 109.257812 18.5 L 109.257812 93.242188 C 109.257812 93.769531 109.234375 94.289062 109.183594 94.8125 C 109.128906 95.335938 109.054688 95.851562 108.953125 96.367188 C 108.847656 96.882812 108.722656 97.390625 108.570312 97.890625 C 108.417969 98.394531 108.242188 98.886719 108.039062 99.371094 C 107.839844 99.855469 107.617188 100.332031 107.367188 100.792969 C 107.121094 101.253906 106.851562 101.703125 106.558594 102.140625 C 106.269531 102.578125 105.957031 103 105.625 103.402344 C 105.292969 103.808594 104.9375 104.199219 104.566406 104.566406 C 104.199219 104.9375 103.808594 105.292969 103.402344 105.625 C 103 105.957031 102.578125 106.269531 102.140625 106.558594 C 101.703125 106.851562 101.253906 107.121094 100.792969 107.367188 C 100.332031 107.617188 99.855469 107.839844 99.371094 108.039062 C 98.886719 108.242188 98.394531 108.417969 97.890625 108.570312 C 97.390625 108.722656 96.882812 108.847656 96.367188 108.953125 C 95.851562 109.054688 95.335938 109.128906 94.8125 109.183594 C 94.289062 109.234375 93.769531 109.257812 93.242188 109.257812 L 18.5 109.257812 C 17.976562 109.257812 17.453125 109.234375 16.929688 109.183594 C 16.410156 109.128906 15.890625 109.054688 15.375 108.953125 C 14.859375 108.847656 14.351562 108.722656 13.851562 108.570312 C 13.347656 108.417969 12.855469 108.242188 12.371094 108.039062 C 11.886719 107.839844 11.414062 107.617188 10.949219 107.367188 C 10.488281 107.121094 10.039062 106.851562 9.601562 106.558594 C 9.164062 106.269531 8.746094 105.957031 8.339844 105.625 C 7.933594 105.292969 7.546875 104.9375 7.175781 104.566406 C 6.804688 104.199219 6.453125 103.808594 6.121094 103.402344 C 5.785156 103 5.472656 102.578125 5.183594 102.140625 C 4.890625 101.703125 4.621094 101.253906 4.375 100.792969 C 4.128906 100.332031 3.902344 99.855469 3.703125 99.371094 C 3.503906 98.886719 3.324219 98.394531 3.171875 97.890625 C 3.019531 97.390625 2.894531 96.882812 2.792969 96.367188 C 2.6875 95.851562 2.613281 95.335938 2.5625 94.8125 C 2.507812 94.289062 2.484375 93.769531 2.484375 93.242188 L 2.484375 18.5 C 2.484375 17.976562 2.507812 17.453125 2.5625 16.929688 C 2.613281 16.410156 2.6875 15.890625 2.792969 15.375 C 2.894531 14.859375 3.019531 14.351562 3.171875 13.851562 C 3.324219 13.347656 3.503906 12.855469 3.703125 12.371094 C 3.902344 11.886719 4.128906 11.414062 4.375 10.949219 C 4.621094 10.488281 4.890625 10.039062 5.183594 9.601562 C 5.472656 9.164062 5.785156 8.746094 6.121094 8.339844 C 6.453125 7.933594 6.804688 7.546875 7.175781 7.175781 C 7.546875 6.804688 7.933594 6.453125 8.339844 6.121094 C 8.746094 5.785156 9.164062 5.472656 9.601562 5.183594 C 10.039062 4.890625 10.488281 4.621094 10.949219 4.375 C 11.414062 4.128906 11.886719 3.902344 12.371094 3.703125 C 12.855469 3.503906 13.347656 3.324219 13.851562 3.171875 C 14.351562 3.019531 14.859375 2.894531 15.375 2.792969 C 15.890625 2.6875 16.410156 2.613281 16.929688 2.5625 C 17.453125 2.507812 17.976562 2.484375 18.5 2.484375 Z M 18.5 2.484375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    gradientTransform: "matrix(106.77544, 0, 0, 106.77544, 2.483921, 2.483918)",
    y1: 1,
    x2: 0.5,
    gradientUnits: "userSpaceOnUse",
    y2: 2.37207e-8,
    id: "5b44d27f7b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.999573%, 13.699341%, 23.098755%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.999573%, 13.763428%, 23.162842%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.00415%, 14.009094%, 23.408508%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.01178%, 14.370728%, 23.770142%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.017883%, 14.730835%, 24.130249%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.023987%, 15.090942%, 24.491882%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.03009%, 15.452576%, 24.85199%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.036194%, 15.812683%, 25.213623%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.043823%, 16.174316%, 25.57373%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.049927%, 16.534424%, 25.935364%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.05603%, 16.896057%, 26.295471%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.062134%, 17.256165%, 26.657104%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.069763%, 17.617798%, 27.017212%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.075867%, 17.977905%, 27.378845%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.08197%, 18.339539%, 27.738953%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.088074%, 18.699646%, 28.100586%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.094177%, 19.061279%, 28.460693%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.101807%, 19.421387%, 28.820801%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.10791%, 19.78302%, 29.182434%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.114014%, 20.143127%, 29.542542%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.120117%, 20.504761%, 29.904175%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.127747%, 20.864868%, 30.264282%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.13385%, 21.224976%, 30.625916%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.139954%, 21.586609%, 30.986023%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.146057%, 21.946716%, 31.347656%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.152161%, 22.30835%, 31.707764%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.15979%, 22.668457%, 32.069397%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.165894%, 23.03009%, 32.429504%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.171997%, 23.390198%, 32.791138%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.178101%, 23.751831%, 33.151245%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.18573%, 24.111938%, 33.512878%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.191833%, 24.473572%, 33.872986%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.197937%, 24.833679%, 34.234619%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.204041%, 25.195312%, 34.594727%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.210144%, 25.55542%, 34.954834%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.217773%, 25.917053%, 35.316467%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.223877%, 26.277161%, 35.676575%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.22998%, 26.638794%, 36.038208%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.236084%, 26.998901%, 36.398315%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.243713%, 27.359009%, 36.759949%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.249817%, 27.720642%, 37.120056%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.25592%, 28.08075%, 37.481689%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.262024%, 28.442383%, 37.841797%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.268127%, 28.80249%, 38.20343%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.275757%, 29.164124%, 38.563538%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.28186%, 29.524231%, 38.925171%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.287964%, 29.885864%, 39.285278%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.294067%, 30.245972%, 39.646912%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.301697%, 30.607605%, 40.007019%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.3078%, 30.967712%, 40.368652%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.313904%, 31.329346%, 40.72876%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.320007%, 31.689453%, 41.088867%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.326111%, 32.051086%, 41.4505%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.33374%, 32.411194%, 41.810608%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.339844%, 32.772827%, 42.172241%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.345947%, 33.132935%, 42.532349%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.352051%, 33.493042%, 42.893982%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.35968%, 33.854675%, 43.254089%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.365784%, 34.214783%, 43.615723%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.371887%, 34.576416%, 43.97583%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.377991%, 34.936523%, 44.337463%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.384094%, 35.298157%, 44.697571%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.391724%, 35.658264%, 45.059204%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.396301%, 35.969543%, 45.368958%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a34300bba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5a2aaf301)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5b44d27f7b)",
    d: "M 2.484375 2.484375 L 2.484375 109.257812 L 109.257812 109.257812 L 109.257812 2.484375 Z M 2.484375 2.484375 ",
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 43.984375 77.351562 L 43.984375 43.984375 C 43.984375 42.734375 44.679688 41.96875 46.070312 41.691406 L 74.847656 35.851562 C 76.378906 35.574219 77.210938 36.269531 77.351562 37.9375 L 77.351562 63.378906 C 77.351562 65.464844 74.222656 66.855469 67.96875 67.550781 C 56.082031 69.425781 57.957031 89.449219 74.222656 84.023438 C 80.480469 81.730469 81.523438 75.683594 81.523438 69.636719 L 81.523438 20.835938 C 81.523438 20.835938 81.523438 16.664062 77.976562 17.707031 L 42.523438 25.007812 C 42.523438 25.007812 39.8125 25.425781 39.8125 28.761719 L 39.8125 71.09375 C 39.8125 73.179688 36.683594 74.570312 30.429688 75.265625 C 18.542969 77.144531 20.417969 97.164062 36.683594 91.742188 C 42.941406 89.449219 43.984375 83.398438 43.984375 77.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicapple);
export default __webpack_public_path__ + "static/media/musicapple.cc2a3093a492b383b237da15a827eeee.svg";
export { ForwardRef as ReactComponent };